export const SET_INFO_USER_LOGGED = 'SET_INFO_USER_LOGGED';
export const  REMOVE_INFO_USER_LOGGED = 'REMOVE_INFO_USER_LOGGED';